import { FirebaseApp, FirebaseOptions, getApp, getApps, initializeApp } from "firebase/app";
import { Database, getDatabase } from "firebase/database";

const hasValue = (value?: string): boolean =>
  typeof value === "string" && value.trim().length > 0;

export const firebaseRealtimeDatabaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseRealtimeDatabaseConfigured = (): boolean =>
  hasValue(firebaseRealtimeDatabaseConfig.apiKey) &&
  hasValue(firebaseRealtimeDatabaseConfig.databaseURL) &&
  hasValue(firebaseRealtimeDatabaseConfig.projectId) &&
  hasValue(firebaseRealtimeDatabaseConfig.appId);

let cachedFirebaseApp: FirebaseApp | null = null;

export const getFirebaseApp = (): FirebaseApp | null => {
  if (!isFirebaseRealtimeDatabaseConfigured()) {
    return null;
  }

  if (cachedFirebaseApp) {
    return cachedFirebaseApp;
  }

  cachedFirebaseApp = getApps().length > 0
    ? getApp()
    : initializeApp(firebaseRealtimeDatabaseConfig);

  return cachedFirebaseApp;
};

export const getFirebaseRealtimeDatabase = (): Database | null => {
  const firebaseApp = getFirebaseApp();

  if (!firebaseApp) {
    return null;
  }

  return getDatabase(firebaseApp);
};
